import PortalClienteService from "services/bases/PortalClienteService";

class PedidoLicencaService extends PortalClienteService{
    async CalcularNovoValor(tenantId, pedidosLicenca){
        return await this.post(`pedidoLicenca/CalcularNovoValor?tenantId=${tenantId}`,pedidosLicenca)
    }
}

export default new PedidoLicencaService();